/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ServiceCharges {
    angular.module("meevo.plugins.serviceCharges", []);
}